import React from "react";
import PropTypes from "prop-types";

const SectionJumpNav = ({ items, label = "Pack sections", onNavigate }) => (
  <nav aria-label={label} className="wsm-section-jump">
    <ul>
      {items.map(({ href, icon: Icon, label: itemLabel }) => (
        <li key={href}>
          <a href={href} onClick={onNavigate ? (event) => onNavigate(event, href) : undefined}>
            {Icon && <Icon aria-hidden="true" />}
            <span>{itemLabel}</span>
          </a>
        </li>
      ))}
    </ul>
  </nav>
);

SectionJumpNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({ href: PropTypes.string.isRequired, icon: PropTypes.elementType, label: PropTypes.string.isRequired })).isRequired,
  label: PropTypes.string,
  onNavigate: PropTypes.func,
};

export default SectionJumpNav;
